import { render } from "./TalkCard.vue?vue&type=template&id=7ece8852&scoped=true"
import script from "./TalkCard.vue?vue&type=script&lang=js"
export * from "./TalkCard.vue?vue&type=script&lang=js"

import "./TalkCard.vue?vue&type=style&index=0&id=7ece8852&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ece8852"]])

export default __exports__